import React from 'react';
import tw from 'twin.macro';

import Heading from './Heading';

interface ImpactHeroProps {
  title: string;
}

export const heroImgStyles = tw`relative z-10 w-full`;

const ImpactHero: React.FC<ImpactHeroProps> = ({ title, children }) => (
  <div tw="relative mb-12">
    {children}
    <div tw="absolute w-full top-1/2 transform -translate-y-1/2 z-20">
      <div tw="container">
        <Heading level="h1" tw="my-0 text-white">
          <span tw="block text-4xl md:(text-6xl) lg:(text-7xl) xl:(text-9xl)">Votre impact</span>
          <span tw="block">{title}</span>
        </Heading>
      </div>
    </div>
  </div>
);

export default ImpactHero;
